import { Box, Typography } from '@mui/material';
import { StyledCard } from 'shared/ui/Card/StyledCard';
import { MoreInfo } from 'shared/ui/MoreInfo/MoreInfo';
import { UserProfileType } from 'entities/user/model/types';
import { CountrySelectId } from 'shared/consts';

type UserInfoPropsType = {
  profile: UserProfileType | undefined;
  walletBalance?: number;
};

export const UserInfo = ({ profile, walletBalance }: UserInfoPropsType) => {
  const allowedOptions = ['B2B', 'B2C', 'B2CR'];
  const profileOptions =
    profile && allowedOptions.filter((option) => profile[`is_${option.toLowerCase()}` as keyof UserProfileType]);

  return (
    <>
      <Box component={StyledCard}>
        <Typography>Пользовательские данные</Typography>
        <Box
          style={{
            display: 'flex',
            marginTop: '12px',
          }}
        >
          <div
            className="column"
            style={{ width: '250px' }}
          >
            <MoreInfo>
              <div className="title">ID</div>
              <div className="content">{profile?.id ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Телефон</div>
              <div className="content">{profile?.phone ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Device ID</div>
              <div className="content">{profile?.device_id ?? '---'}</div>
            </MoreInfo>
          </div>
          <div
            className="column"
            style={{ width: '250px' }}
          >
            <MoreInfo>
              <div className="title">Дата регистрации</div>
              <div className="content">{profile?.registration_date ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Направление</div>
              <div
                style={{ textTransform: 'uppercase' }}
                className="content"
              >
                {profileOptions?.join(' ') || '---'}
              </div>
            </MoreInfo>
          </div>
          <div
            className="column"
            style={{ width: '250px' }}
          >
            <MoreInfo>
              <div className="title">Источник</div>
              <div className="content">{profile?.source?.name ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Роль</div>
              <div className="content">{profile?.user_roles?.map((item) => item.name).join(', ') ?? '---'}</div>
            </MoreInfo>
          </div>
        </Box>
      </Box>

      <Box component={StyledCard}>
        <Typography>Баланс кошелька</Typography>
        <Box
          style={{
            display: 'flex',
          }}
        >
          <div
            className="column"
            style={{ width: '250px' }}
          >
            <MoreInfo>
              <div className="content">{walletBalance ?? '---'}</div>
            </MoreInfo>
          </div>
        </Box>
      </Box>

      <Box component={StyledCard}>
        <Typography>Анкетные данные</Typography>
        <Box
          style={{
            marginTop: '12px',
            display: 'flex',
          }}
        >
          <div
            className="column"
            style={{ width: '250px' }}
          >
            <MoreInfo>
              <div className="title">Имя</div>
              <div className="content">{profile?.first_name ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Фамилия</div>
              <div className="content">{profile?.last_name ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Отчество</div>
              <div className="content">{profile?.middle_name ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">Город</div>
              <div className="content">{profile?.city?.name ?? '---'}</div>
            </MoreInfo>
            <MoreInfo>
              <div className="title">
                {profile?.city?.country.id === 3 || profile?.city?.country.id === 4 ? 'ИНН' : 'ИИН'}
              </div>
              <div className="content">{profile?.iin ?? '---'}</div>
            </MoreInfo>
            {profile?.city?.country?.id === CountrySelectId.KG || profile?.city?.country?.id === CountrySelectId.UZ ? (
              <>
                <MoreInfo>
                  <div className="title">Номер паспорта</div>
                  <div className="content">{profile?.document?.document_number ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Дата выдачи паспорта</div>
                  <div className="content">{profile?.document?.issued_at ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Дата истечения срока паспорта</div>
                  <div className="content">{profile?.document?.expiration_at ?? '---'}</div>
                </MoreInfo>
                <MoreInfo>
                  <div className="title">Персональный номер</div>
                  <div className="content">{profile?.document?.personal_number ?? '---'}</div>
                </MoreInfo>
              </>
            ) : null}
          </div>
          <div
            className="column"
            style={{ width: '250px', paddingTop: '126px' }}
          >
            <MoreInfo>
              <div className="title">Страна</div>
              <div className="content">{profile?.city?.country?.name ?? '---'}</div>
            </MoreInfo>
          </div>
        </Box>
      </Box>
    </>
  );
};
